import type { ReactElement } from 'react'

export function TypeMarkYearn(props: React.SVGProps<SVGSVGElement> & { color?: string }): ReactElement {
  const { color = '#0657F9', ...svgProps } = props
  return (
    <svg
      version={'1.1'}
      id={'Layer_1'}
      xmlns={'http://www.w3.org/2000/svg'}
      xmlnsXlink={'http://www.w3.org/1999/xlink'}
      x={'0px'}
      y={'0px'}
      viewBox={'0 0 929.7 256.1'}
      enableBackground={'new 0 0 929.7 256.1'}
      xmlSpace={'preserve'}
      {...svgProps}
    >
      <g>
        <path
          fill={color}
          d={
            'M876.8,41.1c-9.3,0-17.1,1.5-23.4,4.6c-6.3,3.1-11.7,7.4-16.2,12.8l-3.2-16h-30.7v128.2h35.2v-65.6 c0-11.1,2.5-19.8,7.5-25.9c5-6.1,12.1-9.2,21.2-9.2c17.3,0,25.9,11.1,25.9,33.2v67.6h35.2v-69.6c0-21.4-4.8-36.8-14.5-46.1 C904.1,45.8,891.7,41.1,876.8,41.1 M783.6,42.6c-9.5,0-17,1.6-22.7,4.9c-5.7,3.2-10.4,8-14.2,14.3l-3.2-19.2h-31.9v128.2h35.2V108 c0-10.3,2.3-18.5,7-24.4c4.7-6,12-9,21.9-9h14V42.6H783.6z M630.8,146.9c-5.8,0-10.4-1.3-13.8-4c-3.4-2.7-5.1-6.2-5.1-10.7 c0-5.3,2-9.4,6.1-12.3c4.1-2.9,9.8-4.4,17.1-4.4h25.7v2.5c-0.2,8.8-2.9,15.8-8.2,21.1C647.2,144.3,640,146.9,630.8,146.9 M638.6,41.1c-17.3,0-31.2,3.6-41.6,10.8c-10.5,7.2-16.3,17.4-17.5,30.5h33.9c0.8-4.8,3.4-8.6,7.6-11.5c4.2-2.8,9.7-4.2,16.3-4.2 c7.1,0,12.8,1.7,17.1,5c4.2,3.3,6.4,7.9,6.4,13.7V92h-25.2c-19.3,0-34,3.7-44,11c-10.1,7.3-15.1,17.8-15.1,31.4 c0,12,4.2,21.3,12.6,27.9c8.4,6.7,19.7,10,33.8,10c8.6,0,16.1-1.5,22.3-4.5c6.2-3,11.8-7.4,16.6-13.2l2.7,16.2h30.9V87.5 c0-15.1-4.9-26.6-14.8-34.5C670.7,45.1,656.7,41.1,638.6,41.1 M472,91.8c1-7.5,4.1-13.4,9.4-17.8c5.2-4.4,11.7-6.6,19.3-6.6 c8,0,14.6,2.1,19.8,6.4c5.2,4.2,8.4,10.3,9.6,18.1H472z M434.6,107c0,13.1,2.8,24.6,8.4,34.5c5.6,9.9,13.5,17.5,23.9,22.8 c10.4,5.3,22.7,8,37,8c11,0,20.7-2,29.2-5.9c8.5-3.9,15.3-9.3,20.4-16.1c5.2-6.8,8.4-14.5,9.7-22.9h-34.7c-1.5,6-4.6,10.5-9.4,13.6 c-4.7,3.1-10.7,4.6-17.8,4.6c-9,0-16-2.7-21.2-8c-5.2-5.3-8.1-12.6-9-21.9v-1h93c0.7-3.5,1-7.5,1-12c-0.2-12.5-3-23.3-8.6-32.5 c-5.6-9.2-13.3-16.4-23.2-21.4c-9.9-5.1-21.3-7.6-34.3-7.6c-12.8,0-24.1,2.7-33.8,8.1c-9.7,5.4-17.3,13.1-22.7,22.9 C437.3,82.1,434.6,93.7,434.6,107 M300.2,42.6l49.4,128.9l-3.2,8.5c-1.8,4.3-3.7,7.2-5.7,8.7c-2,1.5-5.2,2.2-9.7,2.2h-19.5v29.7 h34.2c6.5,0,11.8-1.1,15.8-3.4c4.1-2.2,7.4-5.6,10.1-10c2.7-4.4,5.5-10.5,8.5-18.3l56.9-146.4h-37.7l-30.4,92l-31.2-92H300.2z'
          }
        />
      </g>
      <g>
        <path
          fill={color}
          d={
            'M201.9,98.5l-32.4,32.4c1.8,5.9,2.7,12.2,2.7,18.5c0,17.1-6.7,33.2-18.7,45.3c-12.1,12.1-28.2,18.7-45.3,18.7                    s-33.2-6.7-45.3-18.7c-12.1-12.1-18.7-28.2-18.7-45.3c0-6.4,0.9-12.6,2.7-18.5L14.4,98.5c-8.2,15.1-12.9,32.5-12.9,51                    c0,58.9,47.8,106.7,106.7,106.7s106.7-47.8,106.7-106.7C214.9,131,210.2,113.6,201.9,98.5z'
          }
        />
        <polygon
          fill={color}
          points={'86.8,170.7 129.5,170.7 129.5,102.9 202.2,30.2 172,0 108.2,63.8 44.4,0 14.2,30.2 86.8,102.8'}
        />
      </g>
    </svg>
  )
}
